import { manureStockAnalysisFields, manureStockTotalFields } from "../shared/stocks";

export const stocks = {

    manureStockAnalysisFields,
    manureStockTotalFields

}